var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:[_vm.color, _vm.variant + '--text', 'rounded-circle', _vm.$attrs.class],attrs:{"icon":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }